import { render, staticRenderFns } from "./RemovableList.vue?vue&type=template&id=e38b51d0&scoped=true&"
import script from "./RemovableList.vue?vue&type=script&lang=js&"
export * from "./RemovableList.vue?vue&type=script&lang=js&"
import style0 from "./RemovableList.vue?vue&type=style&index=0&id=e38b51d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b51d0",
  null
  
)

export default component.exports